/**
 * Профили правил полей шаблона (фаза 6).
 * Соответствует backend/app/schemas/rule_profile.py
 */

export interface RuleProfileItemCreate {
  rule_type_id: number;
  value: Record<string, unknown>;
  priority: number;
}

export interface RuleProfileItem extends RuleProfileItemCreate {
  id: number;
  profile_id: number;
  created_at: string;
}

export interface RuleProfile {
  id: number;
  code: string;
  name: string;
  description?: string | null;
  organization_kls_id?: number | null;
  is_active: boolean;
  created_by?: string | null;
  created_at: string;
  updated_at?: string | null;
  items: RuleProfileItem[];
}

export interface RuleProfileListResponse {
  items: RuleProfile[];
  total: number;
  skip: number;
  limit: number;
}

export interface ApplyRuleProfileToFieldsRequest {
  profile_id: number;
  field_ids: number[];
}

/** Профиль по умолчанию для мастера «положительное число» (если есть в БД). */
export const DEFAULT_POSITIVE_NUMBER_PROFILE_CODE = "positive_number";
